import {Component} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
  standalone: false,
  selector: 'app-generic-confirmation',
  templateUrl: './generic-confirmation.component.html',
  providers: [DialogService],
})
export class GenericConfirmationComponent {
  message: string = "";

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig) {
    this.message = this.config.data.message;
  }

  close() {
    this.ref.close();
  }
}
